import { useContext, useEffect, useState } from 'react'
import { AuthContext, AuthProvider } from '../contexts/AuthContext'
import { NotificationProvider } from '../contexts/NotificationContext'
import ApiService from '../services/api'
import WebSocketService from '../services/websocket'
import { storage } from '../utils/helpers'
import Dashboard from './Dashboard'
import LoginScreen from './LoginScreen'

// Services instances (shared across app)
const apiService = new ApiService()
const webSocketService = new WebSocketService()

function TradesSavvyApp() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </AuthProvider>
  )
}

function AppContent() {
  const { user, setUser, logout } = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const initializeApp = async () => {
      // Check for existing session
      const savedUser = storage.get('energytrades_user')
      if (savedUser && savedUser.token) {
        try {
          // Try to verify token with backend
          apiService.setToken(savedUser.token)
          await apiService.request('/health')
          
          setUser(savedUser)
          console.log(`Bentornato ${savedUser.username}!`)
        } catch (error) {
          console.log('Saved token is invalid, showing login screen')
          storage.remove('energytrades_user')
        }
      }
      setIsLoading(false)
    }

    initializeApp()
  }, [setUser])

  useEffect(() => {
    // Set up API and WebSocket services when user changes
    if (user) {
      apiService.setToken(user.token)
      webSocketService.setToken(user.token)
      
      // Connect WebSocket
      webSocketService.connect().catch(error => {
        console.warn('WebSocket connection failed:', error)
      })
    } else {
      apiService.setToken(null)
      webSocketService.disconnect()
    }
  }, [user])

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div>Caricamento...</div>
      </div>
    )
  }

  return (
    <div className="energytrades-app">
      {user ? (
        <Dashboard 
          user={user}
          apiService={apiService}
          webSocketService={webSocketService}
          onLogout={logout}
        />
      ) : (
        <LoginScreen 
          apiService={apiService}
          onLogin={setUser}
        />
      )}
    </div>
  )
}

export default TradesSavvyApp
